import React, { useEffect } from 'react';

import { Navigate, useSearchParams } from 'react-router';

import { ERROR_PAGE_ROUTE } from '../../src/routes/routes';
import { replaceLocation } from '../helpers/replaceLocation';
import { FullPageHomeLoader } from './FullPageHomeLoader';

const ALLOWED_HOST_NAMES = ['consumer.simplersell.com', 'consumer.opendoor.com'];

const getAllowedRedirectURI = (redirectURI: string | null): string | undefined => {
  if (!redirectURI) {
    return undefined;
  }

  try {
    const redirectURL = new URL(redirectURI);

    const isAllowed =
      redirectURL.protocol === 'https:' &&
      redirectURL.port === '' &&
      ALLOWED_HOST_NAMES.includes(redirectURL.hostname);

    return isAllowed ? redirectURI : undefined;
  } catch {
    return undefined;
  }
};

// This welcome redirect page is for the partner <> opendoor direct handoff experience
const WelcomeRedirectPage: React.FC<unknown> = () => {
  const [searchParams] = useSearchParams();
  const redirectURI = getAllowedRedirectURI(searchParams.get('redirect_uri'));

  useEffect(() => {
    if (redirectURI) {
      replaceLocation(redirectURI);
    }
  }, [redirectURI]);

  if (!redirectURI) {
    return <Navigate to={ERROR_PAGE_ROUTE} replace />;
  }

  return <FullPageHomeLoader />;
};

export default WelcomeRedirectPage;
